import { useState } from "react";

/**
 * Admin import pages: download a coach's library as JSON, to attach to Claude
 * when converting that coach's files. `libraryPath` is the controller route
 * that serves the download (it takes ?coachEmail=).
 */
const CoachLibraryDownload = ({
  defaultEmail = "",
  libraryPath,
  description,
}) => {
  const [email, setEmail] = useState(defaultEmail);
  const [error, setError] = useState("");
  const trimmed = email.trim();
  const href = `${libraryPath}?coachEmail=${encodeURIComponent(trimmed)}`;

  // Fetch the file instead of letting the browser download the URL: a failed
  // request would otherwise be saved as the error page.
  const download = async (e) => {
    e.preventDefault();
    if (!trimmed) return;
    setError("");
    try {
      const response = await fetch(href);
      if (!response.ok) {
        const data = await response.json().catch(() => null);
        setError(data?.error?.message ?? "Could not download the library");
        return;
      }
      const disposition = response.headers.get("Content-Disposition") ?? "";
      const filename = /filename="([^"]+)"/.exec(disposition)?.[1];
      const url = URL.createObjectURL(await response.blob());
      const link = document.createElement("a");
      link.href = url;
      link.download = filename ?? "library.json";
      link.click();
      URL.revokeObjectURL(url);
    } catch {
      setError("Could not download the library");
    }
  };

  return (
    <div className="admin-import-form admin-import-library">
      <div className="form-row">
        <div className="form-row-item">
          <label htmlFor="library-coach-email">Coach library</label>
          <input
            id="library-coach-email"
            type="email"
            placeholder="coach@example.com"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setError("");
            }}
          />
        </div>
        {/* biome-ignore lint/a11y/useSemanticElements: a real download link so the browser saves the file; role only picks up button styles */}
        <a //NOSONAR
          role="button"
          data-button-type="secondary"
          download
          href={href}
          aria-disabled={!trimmed}
          onClick={download}
        >
          Download library JSON
        </a>
      </div>
      {error && <p role="alert">{error}</p>}
      <p>{description}</p>
    </div>
  );
};

export default CoachLibraryDownload;
